
import { X } from 'lucide-react';
const References = () => {
   
  
    return (
        <div id="references">
          <h1>This is the Refereces section</h1>
         </div>
      
  )
}
 
export default References;